import client from '../config/api';
import { cacheRecord } from '../services/db';
import { SYNCHRONIZE_LOCAL_DATABASE } from '../store/offline/actions/actionTypes';

export default {
  computed: {
    currentJob() {
      return this.$store.state.currentJob;
    },

    isJobCheckedOut() {
      return (
        this.currentJob.checkedOut === this.user._id ||
        this.currentJob.checkedOut === this.user.id
      );
    },
  },
  methods: {
    async saveJobOffline() {
      try {
        this.isLoading = true;
        await this.checkoutJobOffline();
        // Get an cache latest version of the job
        const { id } = this.$route.params;
        const { data: job } = await client.get(`/job/${id}`);
        await cacheRecord('job', job, job._id);

        const { data: rootTasks } = await client.get(`/task/job/${id}`);
        const tasks = await this.processFolder(rootTasks);

        const promises = tasks.map(async (task) => {
          if (task.taskType === 'diagram') {
            const result = await client.get(`/bubbles/${task._id}`);
            result.data.forEach((bubble) => {
              cacheRecord('bubble', bubble, job._id);
            });
          }

          if (task.taskType === 'instruction') {
            const result = await client.get(`/questions/${task._id}`);
            result.data.forEach((question) => {
              cacheRecord('question', question, job._id);
            });
          }

          await cacheRecord('task', task, job._id);
        });
        await Promise.all(promises);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async checkoutJobOffline() {
      const { id } = this.$route.params;
      await client.patch(`/job/offline-checkout/${id}`);
      await this.$store.dispatch('getJob', id);
      this.$buefy.toast.open({
        duration: 3000,
        message: 'Job was saved successfully!',
        type: 'is-success',
        position: 'is-bottom-left',
      });
      console.log('Checkout job offline');
    },

    async processFolder(tasksToProcess) {
      const tasks = [];
      const processSubFolders = [];
      tasksToProcess.forEach((task) => {
        tasks.push(task);
        if (task.taskType === 'folder') {
          processSubFolders.push(
            client
              .get(`/task/job/${task.jobId}?folderId=${task._id}`)
              .then(({ data: folderTasks }) =>
                this.processFolder(folderTasks, client)
              )
          );
        }
      });

      await Promise.all(processSubFolders).then((subfoldersTasks) => {
        subfoldersTasks.forEach((subfolderTasks) => {
          tasks.push(...subfolderTasks);
        });
      });

      return tasks;
    },

    async checkinJobOffline() {
      try {
        this.isLoading = true;
        const { id } = this.$route.params;
        // TODO: Sync job and upload all local data to server
        await client.patch(`/job/offline-checkin/${id}`);
        await this.$store.dispatch('getJob', id);

        await this.$store.dispatch(SYNCHRONIZE_LOCAL_DATABASE, {
          manualSync: true,
          toast: this.$buefy.toast,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
